import React from 'react';
import useExpandableImage from '../hooks/useExpandableImage';

const ExpandableImage = ({ src, alt, variant = "v1", className = "" }) => {
    const { isExpanded, needsExpansion, containerRef, onImageLoad, toggleExpand } = useExpandableImage();

    if (variant === "v1") {
        return (
            <div ref={containerRef} className={`relative w-full ${needsExpansion && !isExpanded ? 'max-h-[500px] overflow-hidden rounded-lg' : ''}`}>
                <img 
                    src={src} 
                    alt={alt} 
                    className={`w-full rounded-lg border-2 border-slate-200/10 transition hover:border-slate-200/30 ${className}`}
                    onLoad={onImageLoad}
                />
                
                {needsExpansion && !isExpanded && (
                    <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-[#020617] via-[#020617]/90 to-transparent flex items-end justify-center pb-6">
                        <button 
                            onClick={toggleExpand}
                            className="bg-slate-800 text-off-white px-6 py-3 rounded-full font-semibold border border-slate-600 shadow-xl hover:bg-slate-700 transition-colors flex items-center gap-2"
                        >
                            <span>Click to Expand</span>
                            <span>▼</span>
                        </button>
                    </div>
                )}
                {needsExpansion && isExpanded && (
                    <div className="flex justify-center mt-6">
                        <button 
                            onClick={toggleExpand}
                            className="text-cherry-blossom hover:text-off-white font-semibold transition-colors flex items-center gap-2"
                        >
                            <span>Collapse Image</span>
                            <span>▲</span>
                        </button>
                    </div>
                )}
            </div>
        );
    }

    // Persona Variant
    return (
        <div ref={containerRef} className={`relative ${needsExpansion && !isExpanded ? 'max-h-[500px] overflow-hidden' : ''}`}>
            {/* Persona Shadow Offset */}
            <div className="absolute  bg-black transform translate-x-2 translate-y-2" aria-hidden="true"></div>
            
            <img 
                src={src} 
                alt={alt} 
                className={`relative w-full border-4 border-black bg-white ${className}`}
                onLoad={onImageLoad}
            />
            
            {needsExpansion && !isExpanded && (
                <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-black via-black/90 to-transparent flex items-end justify-center pb-6 z-10">
                    <button 
                        onClick={toggleExpand}
                        className="bg-[#FFF200] text-black px-6 py-2 border-4 border-black font-bebas text-xl md:text-2xl shadow-[4px_4px_0_#000] hover:-translate-y-1 transition-transform focus:outline-none focus-visible:ring-4 focus-visible:ring-white"
                    >
                        CLICK TO EXPAND ▼
                    </button>
                </div>
            )}
            {needsExpansion && isExpanded && (
                <div className="flex justify-center mt-8 relative z-10">
                    <button 
                        onClick={toggleExpand}
                        className="bg-black text-[#FFF200] px-6 py-2 border-4 border-white font-bebas text-xl md:text-2xl shadow-[4px_4px_0_#000] hover:-translate-y-1 transition-transform focus:outline-none focus-visible:ring-4 focus-visible:ring-white"
                    >
                        COLLAPSE ▲
                    </button>
                </div>
            )}
        </div>
    );
};

export default ExpandableImage;